import { alpha, Button, Menu, MenuItem, MenuProps, styled } from '@material-ui/core'
import { KeyboardArrowDown, KeyboardArrowUp } from '@material-ui/icons'
import * as React from 'react'
import { useHistory } from 'react-router-dom'
import { getChainById, getChainInfo } from 'src/config'
import { generatePrefixedAddressRoutes, getNetworkRootRoutes } from 'src/routes/routes'
import { OVERVIEW_EVENTS } from 'src/utils/events/overview'
import { trackEvent } from 'src/utils/googleTagManager'
import { Icon } from '@gnosis.pm/safe-react-components'
import NetworkLabel from 'src/components/NetworkLabel/NetworkLabel'
import useSafeAddress from 'src/logic/currentSession/hooks/useSafeAddress'

const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'center',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }: any) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(5),
    minWidth: 280,
    color: theme.palette.mode === 'light' ? 'rgb(55, 65, 81)' : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.selectedOpacity),
      },
    },
  },
}))
interface Props {
  sidebarIsOpen: boolean
}
export default function CustomizedMenus({ sidebarIsOpen }: Props) {
  const history = useHistory()

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const openDrpDwn = Boolean(anchorEl)
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  const chain = getChainInfo()
  const chainId = chain.chainId
  const { shortName, safeAddress } = useSafeAddress()

  return (
    <div className="align-self-center">
      <Button
        className="py-2"
        aria-controls={openDrpDwn ? 'demo-customized-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openDrpDwn ? 'true' : undefined}
        variant="contained"
        color="primary"
        disableElevation
        onClick={handleClick}
        fullWidth
        endIcon={openDrpDwn ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
      >
        {sidebarIsOpen ? chain.chainName : chain.shortName}
        {/* <NetworkLabel flexGrow networkInfo={chain} /> */}
        {/* {chain.chainName} */}
      </Button>
      <StyledMenu anchorEl={anchorEl} open={openDrpDwn} onClose={handleClose}>
        <MenuItem
          disableRipple
          alignItems="center"
          divider
          button
          onClick={() => {
            window.location.href = 'https://tron.walliro.com/mainnet:' + safeAddress
          }}
          href={'https://tron.walliro.com/mainnet:' + safeAddress}
          className="text-center justify-content-between"
        >
          Tron - Mainnet
        </MenuItem>
        <MenuItem
          disableRipple
          alignItems="center"
          divider
          button
          onClick={() => {
            window.location.href = 'https://tron.walliro.com/shasta:' + safeAddress
          }}
          href={'https://tron.walliro.com/shasta:' + safeAddress}
          className="text-center justify-content-between"
        >
          Tron - Shasta (Testnet)
        </MenuItem>
        {getNetworkRootRoutes().map((network) => {
          const chain = getChainById(network.chainId)
          return (
            <MenuItem
              key={network.chainId}
              disableRipple
              alignItems="center"
              divider
              button
              selected={network.chainId === chainId}
              onClick={() => {
                trackEvent({ ...OVERVIEW_EVENTS.SWITCH_NETWORK, label: network.chainId })
                history.push(network.route)
                handleClose()
              }}
              href={network.route}
              className="text-center justify-content-between"
            >
              {/* <NetworkLabel flexGrow networkInfo={getChainById(network.chainId)}> */}
              {chain.chainName}
              {chainId === network.chainId && <Icon type="check" size="sm" color="primary" />}
              {/* </NetworkLabel> */}
            </MenuItem>
          )
        })}
      </StyledMenu>
    </div>
  )
}
